module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/fullscreen-cover/fullscreen-cover.component.scss
// module id = ./src/app/modules/common-module/components/fullscreen-cover/fullscreen-cover.component.scss
// module chunks = 9